module.exports = __webpack_public_path__ + "img/bubble-green.ecb43753.svg";